import getRooms from "../core/select-rooms";
import partyCalendar from "./calendar/calendar";
import orderParty from "./order-party";

const form = document.querySelector('#party-order-form');

if(form != null){
    
    // Calendar
    const party_calendar = partyCalendar();

    const get_rooms = getRooms('#field_room');

    const order_party = new orderParty();

    order_party.init(
        '#party-order-form',
        '#btn-form-buy-party',
        '#wrap-payment-info',
        '#party-payment-button-step-1',
        '#party-payment-button-text',
        '#party-form-process',
        '#party-payment-element',
        '#loading-payment',
        '#party-payment-response',
        '#party-pay-reinit',
        '#party-payment-spinner',
    );

}
    
